import script from "./AppointmentCancellationActionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentCancellationActionModal.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentCancellationActionModal.vue?vue&type=style&index=0&id=7f804821&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f804821"]])

export default __exports__